// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"4afe7e55","245":"6b228d74"}[chunkId] + ".chunk.js";
};